import React, { useState, useEffect } from "react";
import { Link, Redirect } from "react-router-dom";
import SideNav from "../Layout/SideNav";
import SwipeableViews from "react-swipeable-views";
import DeleteIcon from "@material-ui/icons/Delete";
import SearchBar from "material-ui-search-bar";
import Divider from "@material-ui/core/Divider";
import {
  makeStyles,
  createStyles,
  Theme,
  useTheme,
  WithStyles,
  withStyles,
} from "@material-ui/core/styles";
import FormControl from "@mui/material/FormControl";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import AddIcon from "@material-ui/icons/Add";
import GroupIcon from "@material-ui/icons/Group";

import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
// import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import ListItemText from "@material-ui/core/ListItemText";
import TextField from "@material-ui/core/TextField";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Radio, { RadioProps } from "@material-ui/core/Radio";
import Chip from "@material-ui/core/Chip";
import List from "@material-ui/core/List";
import Switch from "@material-ui/core/Switch";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Grid from "@material-ui/core/Grid";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import CloseIcon from "@material-ui/icons/Close";
import { CancelOutlined, Edit, Visibility } from "@material-ui/icons";
import IconButton from "@material-ui/core/IconButton";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import axios from "axios";
import alertify from "alertifyjs";
import APIModel from "../../Models/APIModel";
import $ from "jquery";
import styled from "styled-components";
import * as yup from "yup";
import { useFormik } from "formik";
import {
  Autocomplete,
  Checkbox,
  FormControlLabel,
  RadioGroup,
} from "@mui/material";
import { readAndCompressImage } from 'browser-image-resizer';
import { useFilePicker } from "use-file-picker";
import { useHistory } from "react-router";
import { displayAlertifyError } from "../../util/functions";
import { MenuItem } from "@material-ui/core";
const { v4: uuidv4 } = require("uuid");
const configcompress = {
  quality: 0.7,
  width:600,
  debug: true,
};
const formList = [
  {
    id: 1,
    content: "California Preliminary 20-Day Notice",
    type: "form1",
    link: "",
  },
  {
    id: 2,
    content: "Conditional Waiver And Release On Final Payment",
    type: "form2",
    link: "",
  },
  {
    id: 3,
    content: "Conditional Waiver And Release On Progress Payment",
    type: "form3",
    link: "",
  },
  {
    id: 4,
    content: "Unconditional Waiver And Release On Final Payment",
    type: "form4",
    link: "",
  },
  {
    id: 5,
    content: "Unconditional Waiver And Release On Progress Payment",
    type: "form5",
    link: "",
  },
];

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: "100%",
    flexGrow: 1,
  },
  divider: {
    // Theme Color, or use css color in quote
    background: "#000",
  },
  input: {
    display: "none",
  },
}));

const styles = (theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
    imageContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      marginBottom: theme.spacing(2),
    },
    image: {
      maxWidth: '100%',
      marginBottom: theme.spacing(1),
    },
    descriptionInput: {
      width: '100%',
    },
  });

function ListItemLink(props) {
  return <ListItem button component="a" {...props} />;
}

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const selectOptions = [
  {
    id: 2,
    user_id: 1,
    name: "Bed Room",
    price: 2000,
    note: "Its good",
  },
  {
    id: 3,
    user_id: 1,
    name: "Wash room",
    price: 1000,
    note: "Its good",
  },
  {
    id: 4,
    user_id: 1,
    name: "kitchen",
    price: 1500,
    note: "Its good",
  },
];

const NewEstimate = () => {
  const history = useHistory();
  let get_token = localStorage.getItem("Token");
  let get_userid = localStorage.getItem("user_id");
  let user_status = localStorage.getItem("status");

  const [host, setHost] = useState(APIModel.HOST);
  const [token, setToken] = useState(get_token);
  const [userid, setUserId] = useState(get_userid);
  const [count, setCount] = useState(0);
  const [clients, setClients] = useState([]);
  const [clientData, setClientData] = useState(false);
  const [clientId, setClientId] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [otherMobile, setOtherMobile] = useState("");
  const [address, setAddress] = useState("");
  const [address2, setAddress2] = useState("");
  const [checkboxes, setCheckbox] = useState({
    form1: false,
    form2: false,
    form3: false,
    form4: false,
    form5: false,
  });
  const [openClient, setOpenClient] = useState(false);

  const [selectedItem, setSelectedItem] = useState("");
  const [products, setProducts] = useState([]);

  const [search, setSearch] = useState("");
  const [foundClients, setFoundClients] = useState(clients);
  const [noResult, setNoResult] = useState(false);
  const [descriptionArray, setDescriptionArray] = useState([]);

  const initialInput = [
    {
      prod_id: uuidv4(),
      item_id: "",
      name: "item name",
      description: "",
      rate: 0,
      qty: 0,
      tax: 0,
      total: 0,
    },
  ];
  const [inputList, setInputList] = useState(initialInput);
  const [editTableRow, setEditTableRow] = useState(false);
  const [subtotal, setSubTotal] = useState(0);
  const [addSubTotal, setAddSubTotal] = useState({
    markup: 0,
    discount: 0,
  });
  const [total, setTotal] = React.useState(
    subtotal + +addSubTotal.markup - addSubTotal.discount
  );
  const [taxes, setTaxes] = useState([]);
  const [selectTax, setSelectTax] = useState(0);
  const [totalTax, setTotalTax] = useState(0);
  const [markup, setMarkup] = useState({
    markupTypeValue: "%",
    markupValue: "",
  });
  const [estimateData, setEstimateData] = useState({});

  const [isLoadingSend, setIsLoadingSend] = useState(false);
  const [isLoadingSendAndMail, setIsLoadingSendAndMail] = useState(false);
  const [isSendAndMail, setIsSendAndMail] = useState(false);

  const formatCurrency = (number) => {
    return parseFloat(number).toLocaleString(undefined, {
      maximumFractionDigits: 0,
      minimumFractionDigits: 0
    });
  };
  useEffect(() => {
    axios
      .get(host + "get-taxes", {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: "Bearer " + token,
        },
      })
      .then((res) => setTaxes(res.data.taxes))
      .catch((err) => displayAlertifyError({ error: err }));

    axios
      .get(host + "get-items/" + get_userid, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        setProducts(response.data.items);
      })
      .catch((error) => {
        displayAlertifyError({ error });
      });
  }, []);

  const handleTaxRadio = (percentage) => {
    if (percentage !== null || percentage !== undefined) {
      console.log(percentage);
      setSelectTax(percentage);
      formik.values.tax = percentage;
    }
  };
  const markupHandleChange = (event) => {
    // setMarkupTypeValue(event.target.value);
    // console.log(markupTypeValue);
    const value = event.target.value;
    setMarkup({
      ...markup,
      [event.target.name]: value,
    });
    console.log(markup);
  };
  function saveMarkup(event) { }

  const classes = useStyles({});

  const handleClickOpenClient = () => setOpenClient(true);
  const handleCloseClient = () => setOpenClient(false);

  const handleCheckboxes = (e, id) => {
    setCheckbox({ ...checkboxes, [`form${id}`]: e.target.checked });
    if (e.target.checked) {
      formList.forEach((item) => {
        if (item.id === id)
          item.link = `${APIModel.URL}${item.type}/${get_userid}/${clientId}`;
      });
    } else {
      formList.forEach((item) => {
        if (item.id === id) item.link = "";
      });
    }
  };
  const handleEditRowOpen = (id) => {
    const item = inputList.filter((item) => item.prod_id === id)[0];
    formik.values.id = item.prod_id;
    formik.values.name = item.name;
    if (item.description) {
      formik.values.description = item.description;
    }
    formik.values.qty = item.qty;
    formik.values.rate = item.rate;
    setSelectTax(item.tax);
    setTimeout(() => {
      setEditTableRow(true);
    }, 10);
    if (item.name !== "item name") setSelectedItem(item.name);
    else setSelectedItem("");
  };
  const getTotalTax = () => {
    let newTax = 0;
    inputList.forEach((item) => {
      newTax += item.tax;
    });
    if (totalTax !== newTax) setTotalTax(newTax);
  };
  const getSubtotal = () => {
    let total = 0;
    inputList.forEach((item) => {
      total += item.qty * item.rate;
    });
    if (total !== subtotal) {
      setSubTotal(total);
    }
  };
  const getTotal = () => {
    if (
      total !==
      subtotal + +addSubTotal.markup + +totalTax - addSubTotal.discount
    )
      setTotal(
        subtotal + +addSubTotal.markup + +totalTax - addSubTotal.discount
      );
  };
  const handleEditRowClose = () => setEditTableRow(false);

  React.useEffect(() => {
    getTotal();
    getTotalTax();
  }, [subtotal]);
  React.useEffect(() => {
    getTotal();
  }, [totalTax]);
  React.useEffect(() => {
    getSubtotal();
  }, [inputList]);

  const filter = (event) => {
    console.log(event);
    setNoResult(true);
    const keyword = event;

    if (keyword !== "") {
      const results = clients.filter((client) => {
        return client.name.toLowerCase().startsWith(keyword.toLowerCase());
        // Use the toLowerCase() method to make it case-insensitive
      });
      setFoundClients(results);
    } else {
      setFoundClients(clients);
      // If the text field is empty, show all users
    }

    setSearch(keyword);
  };

  function allFilter() {
    setFoundClients(clients);
  }
  const handleSelectOptions = (e, val) => {
    if (val !== null) {
      products.forEach((item) => {
        if (item.name === val) {
          formik.values.item_id = item.id;
          formik.values.name = item.name;
          formik.values.rate = item.price;
          formik.values.description = item.note;
        }
      });
    } else {
      formik.values.name = "";
      formik.values.rate = "";
    }
    setSelectedItem(val);
  };



  const handleSaveAndSendMail = () => {
    setIsSendAndMail(true);
  };


  const handleSubTotalChange = (e) => {
    if (e.target.value >= 0 && e.target.value !== "-") {
      if (e.target.name === "discount") {
        if (e.target.value < subtotal) {
          setAddSubTotal({
            ...addSubTotal,
            [e.target.name]: e.target.value,
          });
        } else {
          displayAlertifyError({
            error: "Please enter discount less then total amount.",
          });
        }
      } else {
        setAddSubTotal({
          ...addSubTotal,
          [e.target.name]: e.target.value,
        });
      }
    } else if (e.target.value === "")
      if (e.target.name === "discount") {
        if (e.target.value < subtotal) {
          setAddSubTotal({
            ...addSubTotal,
            [e.target.name]: e.target.value,
          });
        } else {
          displayAlertifyError({
            error: "Please enter discount less then total amount.",
          });
        }
      } else {
        setAddSubTotal({
          ...addSubTotal,
          [e.target.name]: 0,
        });
      }
  };
  const handleSubTotalBlur = () => {
    getTotal();
  };
  // handle input change
  // handle click event of the Remove button
  const handleRemoveClick = (id) => {
    if (inputList.length > 1) {
      let newInputList = inputList.filter((item) => item.prod_id !== id);
      setInputList(newInputList);
      displayAlertifyError({ error: "Item has been deleted" });
    } else {
      displayAlertifyError({ error: "last item can not be deleted" });
    }
    getSubtotal();
  };

  // handle click event of the Add button
  const handleAddClick = () => {
    setInputList([
      ...inputList,
      {
        prod_id: uuidv4(),
        item_id: "",
        name: "item name",
        rate: 0,
        qty: 0,
        tax: 0,
        total: 0,
      },
    ]);

    console.log("");
  };

  const saveEstimate = () => {
    let params = { clientid: clientId, items: inputList };
    console.log(params);
  };

  useEffect(() => {
    axios
      .get(host + "get-clients/" + userid, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        setClients(response.data.clients);
        setFoundClients(response.data.clients);
      })
      .catch(function (error) {
        displayAlertifyError({
          error: "There is a problem in your network connection",
        });
      });
  }, [count]);

  function getData(id) {
    axios
      .get(host + "client-detail/" + id, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        setClientId(response.data.client.id);
        setEmail(response.data.client.email);
        setMobile(response.data.client.mobile);
        setOtherMobile(response.data.client.other_mobile);
        setAddress(response.data.client.address);
        setAddress2(response.data.client.address2);
        setClientData(true);
      })
      .catch(function (error) {
        displayAlertifyError({ error });
      });
    setTimeout(() => {
      handleCloseClient();
    }, 500);
  }
  const validationSchema = yup.object({
    id: yup.string().required(),
    name: yup.string().required("name is required"),
    qty: yup.number().required("qty is required").positive().integer(),
    rate: yup.number().required("qty is required").positive().integer(),
  });

  const formik = useFormik({
    initialValues: {
      item_id: "",
      id: "",
      name: "",
      description: "",
      qty: "",
      rate: "",
      tax: 0,
    },
    validationSchema: validationSchema,
    onSubmit: async (values, actions) => {
      const newInput = inputList;
      inputList.forEach((item) => {
        if (item.prod_id === values.id) {
          item.item_id = values.item_id;
          item.name = values.name;
          item.rate = values.rate;
          item.qty = values.qty;
          item.total = values.rate * values.qty;
          item.tax = values.qty * values.tax;
          item.description = values.description;
        }
      });
      const linkList = formList.filter((item) => item.link !== "");
      console.log(linkList);
      const items = inputList.filter((item) => item.name !== "item name");
      if (items.length > 0) {
        const itemslist = JSON.stringify(
          inputList.filter((item) => item.name !== "item name")
        );
        const param = {
          user_id: get_userid,
          items: itemslist,
          forms: JSON.stringify(
            linkList.length === 0
              ? []
              : linkList.map((item) => {
                return item.link;
              })
          ),
        };
        let fd = new FormData();
        for (const key of Object.keys(param)) {
          console.log(`"${key}"`, param[key]);
          fd.append(`${key}`, param[key]);
        }

        if (fd) {
          axios
            .post(host + "save-estimate", fd, {
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                "Access-Control-Allow-Origin": "*",
                Authorization: "Bearer " + token,
              },
            })
            .then((res) => { });
          alertify.success(`${values.name} is added`);
          setInputList(newInput);
          getTotalTax();
          getTotal();
          setSelectTax(0);
          getSubtotal();

          actions.setSubmitting(false);
          actions.resetForm();
          handleEditRowClose();
        }
      }
    },
  });
  const { handleChange, values } = formik;
  
  const [compressedFiles, setCompressedFiles] = useState([]);
  const [compresdone, setCompresdone] = useState(false);

  const [openPhotoSelector, photoSelectorActions] = useFilePicker({
    multiple: true,
    accept: "image/*",
    readAs: "DataURL",
    limitFilesConfig: { max: 10 },
    maxFileSize: 10,
  });

const ImageuploadRest = () => {
  openPhotoSelector();
  Resetphotoupload();
}
  const Resetphotoupload = () => {

    photoSelectorActions.clear();
    setCompresdone(false);
    setCompressedFiles([]);
  }

  const newCompressedFiles = [];
     
  const compressImages = async () => {
    for (let file of photoSelectorActions.plainFiles) {
      try {
        const compressedImage = await readAndCompressImage(file, configcompress);
       
        newCompressedFiles.push(compressedImage);
      } catch (error) {
        console.error('Failed to compress the image.', error);
      }
    }
    setCompressedFiles(newCompressedFiles);
  };
  useEffect(() => {
    console.log(compresdone);
    if (compresdone != true && photoSelectorActions && photoSelectorActions.plainFiles && photoSelectorActions.plainFiles.length) {
      compressImages();
      setCompresdone(true);
    }
  }, [photoSelectorActions]);
  

  const handlePhotoDelete = (ind) => { };
  const [openAttachmentSelector, AttachmentSelectorActions] = useFilePicker({
    multiple: true,
    accept: [".docx", ".doc", ".pdf"],
    readAs: "DataURL",
    limitFilesConfig: { max: 5 },
    maxFileSize: 5,
  });
  const getTodayDate = () => {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0");
    var yyyy = today.getFullYear();
    return `${yyyy}-${mm}-${dd}`;
  };
  const saveValidationSchema = yup.object().shape({
    date: yup.date("date is required"),
    PO_number: yup.number("PO number is required").positive().integer(),
    days_to_pay: yup.number("Days to pay is required"),
  });
  const handleDescriptionChange = (description, index) => {

    const updatedDescriptionArray = [...descriptionArray];
    updatedDescriptionArray[index] = description;
    setDescriptionArray(updatedDescriptionArray);
  };
  const saveFormik = useFormik({
    initialValues: {
      date: estimateData?.formikData?.date ?? getTodayDate(),
      PO_number: estimateData?.formikData?.poNumber,
      days_to_pay: estimateData?.formikData?.daysToPay,
      notes: estimateData?.formikData?.notes,
      photos: estimateData?.formikData?.photos?.length
        ? estimateData?.formikData?.photos
        : [],
      attachments: estimateData?.formikData?.attachments?.length
        ? estimateData?.formikData?.attachments
        : [],
    },
    validationSchema: saveValidationSchema,
    onSubmit: async (values, actions) => {

      const linkList = formList.filter((item) => item.link !== "");
      console.log(linkList);
      const items = inputList.filter((item) => item.name !== "item name");
      if (items.length > 0) {
        const itemslist = JSON.stringify(
          inputList.filter((item) => item.name !== "item name")
        );
        const param = {
          user_id: get_userid,
          client_id: clientId,
          client_email: email,
          sendmail: isSendAndMail,
          po_number: values.PO_number ?? estimateData?.formikData?.poNumber,
          subtotal: subtotal,
          discount: addSubTotal.discount,
          tax: totalTax,
          markup: addSubTotal.markup,
          total: total,
          date: values.date,
          days_to_pay:
            values.days_to_pay ?? estimateData?.formikData?.daysToPay,
          notes: values.notes ?? estimateData?.formikData?.notes,
          items: itemslist,
          forms: JSON.stringify(
            linkList.length === 0
              ? []
              : linkList.map((item) => {
                return item.link;
              })
          ),
        };
        let fd = new FormData();
        for (const key of Object.keys(param)) {
          console.log(`"${key}"`, param[key]);
          fd.append(`${key}`, param[key]);
        }

        compressedFiles.forEach((item, index) => {
          fd.append(`photos[${index}]`, item);
          fd.append(`description[${index}]`, descriptionArray[index] !== undefined ? descriptionArray[index] : '');
        });

        AttachmentSelectorActions.plainFiles.forEach((item, index) => {
          fd.append(`attachments[${index}]`, item);
        });

        if (clientData) {

          if (isSendAndMail === true) {

            setIsLoadingSendAndMail(true);

          } else {

            setIsLoadingSend(true);

          }
          axios
            .post(host + "save-estimate", fd, {
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                "Access-Control-Allow-Origin": "*",
                Authorization: "Bearer " + token,
              },
            })
            .then((res) => {
              if (res.data?.status) {
                alertify.success("Estimate has been saved successfully");
                setTimeout(() => {
                  history.push("/estimates");
                }, 1000);
                actions.setSubmitting(false);
                setAddSubTotal({
                  markup: 0,
                  discount: 0,
                });
                setClientData(false);
                setEmail("");
                setMobile("");
                setOtherMobile("");
                setAddress("");
                setAddress2("");
                setInputList(initialInput);
                setCheckbox({
                  form1: false,
                  form2: false,
                  form3: false,
                  form4: false,
                  form5: false,
                });
                actions.resetForm();
              } else {
                displayAlertifyError({ error: "Error in response" });
              }
              localStorage.removeItem("estimateData");
              setEstimateData({});
              localStorage.removeItem("estimateStatus");
            })
            .finally(() => {
              setIsLoadingSend(false);
              setIsLoadingSendAndMail(false);
            });
        } else {
          displayAlertifyError({ error: "Please select a client" });
        }
      } else {
        displayAlertifyError({ error: "please order something" });
      }
    },
  });

  const { getFieldProps } = saveFormik;

  useEffect(() => {
    const savedData = JSON.parse(localStorage.getItem("estimateData"));

    if (savedData) {
      setEstimateData(savedData);
      setClientId(savedData.clientId);
      if (savedData.addSubTotal) setAddSubTotal(savedData.addSubTotal);
      setTaxes(savedData?.taxes);
      setTotalTax(savedData?.totalTax);
      if (savedData?.markup) setMarkup(savedData.markup);
      setInputList(savedData?.inputList);
      setCheckbox(savedData?.checkboxes);

      if (savedData.clientData?.email) {
        setClientData(true);
        setMobile(savedData.clientData.mobile);
        setEmail(savedData.clientData.email);
        setOtherMobile(savedData.clientData.otherMobile);
        setAddress(savedData.clientData.address);
        setAddress2(savedData.clientData.address2);
      }
    }
  }, []);

  useEffect(() => {
    const dataToSave = {
      clientData: {
        email,
        mobile,
        otherMobile,
        address,
        address2,
      },
      totalTax,
      taxes,
      markup,
      inputList,
      checkboxes,
      addSubTotal,
      formikData: {
        daysToPay:
          getFieldProps("days_to_pay")?.value ??
          estimateData?.formikData?.daysToPay,
        poNumber:
          getFieldProps("PO_number")?.value ??
          estimateData?.formikData?.poNumber,
        date: getFieldProps("date")?.value ?? estimateData?.formikData?.date,
        notes: getFieldProps("notes")?.value ?? estimateData?.formikData?.notes,
        photos:
          getFieldProps("photos")?.value ??
          estimateData?.formikData?.photos ??
          [],
        attachments:
          getFieldProps("attachments")?.value ??
          estimateData?.formikData?.attachments ??
          [],
      },
    };
    if (clientId) dataToSave.clientId = clientId;
    localStorage.setItem("estimateData", JSON.stringify(dataToSave));
  }, [
    clientId,
    email,
    mobile,
    otherMobile,
    address,
    address2,
    totalTax,
    subtotal,
    addSubTotal,
    taxes,
    markup,
    inputList,
    checkboxes,
    getFieldProps,
    estimateData,
  ]);

  if (token) {
    if (user_status === "user") {
      return <Redirect to="/payment"></Redirect>;
    } else {
      return (
        <div className="wrapper">
          <SideNav />
          <div className="main-panel">
            <div className="content">
              <div className="container-fluid">
                <form
                  encType="multipart/form-data"
                  onSubmit={saveFormik.handleSubmit}
                >
                  <DivNewInvoiceHeader>
                    <h3 className="font-weight-bold my-0">Add Estimate</h3>
                    <div>

                      {isLoadingSend ? (
                        <button
                          type="disabled"
                          class="btn btn-primary ml-sm-2"
                          style={{ opacity: ".5" }}
                        >
                          Saving...
                        </button>
                      ) : (
                        <button type="submit" class="btn btn-primary ml-sm-2">
                          Save
                        </button>
                      )}

                      {isLoadingSendAndMail ? (
                        <button
                          type="disabled"
                          class="btn btn-primary ml-sm-2"
                          style={{ opacity: ".5" }}
                        >
                          Saving...
                        </button>
                      ) : (
                        <button type="submit" class="btn btn-primary ml-sm-2" onClick={() => handleSaveAndSendMail()}>
                          Send and Mail
                        </button>
                      )}


                      <Link to="/estimates" className="btn btn-primary">
                        Cancel
                      </Link>
                    </div>
                  </DivNewInvoiceHeader>
                  <Dialog
                    onClose={handleCloseClient}
                    aria-labelledby="customized-dialog-title"
                    open={openClient}
                  >
                    <Box style={{ minWidth: "450px" }}>
                      <DialogTitle
                        id="customized-dialog-title"
                        onClose={handleCloseClient}
                      >
                        Select Client
                      </DialogTitle>
                      <DialogContent dividers>
                        <div className="">
                          <SearchBar
                            placeholder="Search"
                            value={search}
                            onChange={filter}
                            onCancelSearch={allFilter}
                          />
                          <div
                            className="card-body"
                            style={{
                              maxHeight: 300,
                              minHeight: 300,
                              overflow: "auto",
                            }}
                          >
                            <div className={classes.root}>
                              {foundClients && foundClients.length > 0 ? (
                                foundClients.map((item) => (
                                  <List
                                    component="nav"
                                    aria-label="secondary mailbox folders"
                                  >
                                    <ListItem
                                      button
                                      key={item.id}
                                      id={item.id}
                                      onClick={() => getData(item.id)}
                                    >
                                      <ListItemText primary={item.name} />
                                    </ListItem>
                                    <Divider
                                      classes={{ root: classes.divider }}
                                      style={{
                                        backgroundColor: "#ccc",
                                        width: "96%",
                                      }}
                                    />
                                  </List>
                                ))
                              ) : noResult ? (
                                <h4>No results found!</h4>
                              ) : (
                                <h1></h1>
                              )}
                            </div>
                          </div>
                        </div>
                      </DialogContent>
                    </Box>
                  </Dialog>
                  <Dialog
                    onClose={handleEditRowClose}
                    aria-labelledby="customized-dialog-title"
                    open={editTableRow}
                  >
                    <DialogTitle
                      id="customized-dialog-title"
                      onClose={handleEditRowClose}
                    >
                      Edit Info
                    </DialogTitle>
                    <DialogContent dividers>
                      <DivTableRowEdit>
                        <form onSubmit={formik.handleSubmit}>
                          <Autocomplete
                            options={products.map((item) => item.name)}
                            onChange={handleSelectOptions}
                            defaultValue={selectedItem}
                            fullWidth
                            renderInput={(params) => (
                              <TextField
                                variant="outlined"
                                {...params}
                                label="Select Item"
                              />
                            )}
                          />
                          <br />
                          <TextField
                            label="Name"
                            name="name"
                            value={values.name}
                            onChange={handleChange}
                            fullWidth
                            
                          />
                          <div style={{ marginTop: ".5rem" }}>
                            <TextField
                              label="Description"
                              name="description"
                              multiline
                              value={values.description}
                              onChange={handleChange}
                              fullWidth
                            />
                          </div>
                          <div className="qty">
                            <TextField
                              label="Rate"
                              name="rate"
                              value={values.rate}
                              onChange={handleChange}
                              type="number"
                              InputProps={{
                                inputProps: {
                                  min: 1,
                                },
                              }}
                              
                              fullWidth
                            />{" "}
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <TextField
                              type="number"
                              label="Qty"
                              name="qty"
                              required
                              InputProps={{
                                inputProps: {
                                  min: 1,
                                },
                              }}
                              value={values.qty}
                              onChange={handleChange}
                              fullWidth
                            />
                          </div>
                          <br />
                          <div className="radio">
                            <FormControl component="fieldset">
                              <RadioGroup
                                aria-label="taxes"
                                name="taxes-radio-buttons-group"
                              >
                                <FormControlLabel
                                  defaultChecked
                                  onClick={() => setSelectTax(0)}
                                  checked={selectTax === 0}
                                  value={0}
                                  control={<Radio />}
                                  label="0 percent"
                                />
                                {taxes.length > 0
                                  ? taxes.map((item) => {
                                    return (
                                      <FormControlLabel
                                        onClick={() =>
                                          handleTaxRadio(item.percentage)
                                        }
                                        checked={
                                          selectTax === item.percentage
                                        }
                                        key={item.id}
                                        value={item.percentage}
                                        control={<Radio />}
                                        label={item.name}
                                      />
                                    );
                                  })
                                  : ""}
                              </RadioGroup>
                            </FormControl>
                          </div>
                          <div className="btns">
                            <Button
                              onClick={handleEditRowClose}
                              class="btn btn-primary ml-sm-2"
                            >
                              Cancel
                            </Button>
                            {/* <Button
                              
                              className="cancel"
                              color="secondary"
                            >
                              Cancel
                            </Button> */}
                            <Button
                              type="submit"
                              class="btn btn-primary ml-sm-2"
                            >
                              Save
                            </Button>
                          </div>
                        </form>
                      </DivTableRowEdit>
                    </DialogContent>
                  </Dialog>

                  {/* ADD CLIENT DIV */}
                  <div style={{ background: "white", borderRadius: "6px" }}>
                    <div className="container">
                      {/* ADD CLIENT */}
                      <div className="row py-2">
                        <div className="col-md-12">
                          <button
                            type="button"
                            onClick={() => {
                              handleClickOpenClient();
                            }}
                            className="btn btn-outline-primary p-1"
                            style={{}}
                          >
                            {clientData == false ? (
                              <ListItem>
                                {/* <ListItemIcon> */}
                                {/* <GroupIcon style={{ color: "#FC3538" }} /> */}
                                <AddIcon style={{ color: "#FC3538" }} />
                                {/* </ListItemIcon> */}
                                <ListItemText>
                                  {
                                    <Typography variant="h6">
                                      Add Client
                                    </Typography>
                                  }
                                </ListItemText>
                              </ListItem>
                            ) : null}
                            {clientData ? (
                              <ListItem>
                                {email}
                                <br />
                                {mobile}
                                <br />
                                {otherMobile}
                                <br />
                                {address}
                                <br />
                                {address2}
                              </ListItem>
                            ) : null}
                          </button>
                        </div>
                      </div>
                      {/* /ADD CLIENT */}

                      {/* PO NUMBER FIELDS */}
                      <div className="row mt-3">
                        <div className="col-md-4">
                          <TextField
                            className="mb-3 w-100"
                            id="outlined-number"
                            label="Date"
                            type="date"
                            name="date"
                            value={
                              getFieldProps("date").value ??
                              estimateData?.formikData?.date ??
                              getTodayDate()
                            }
                            onChange={getFieldProps("date").onChange}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            variant="outlined"
                            required
                          />
                        </div>

                        <div className="col-md-4">
                          <TextField
                            id="outlined-search"
                            className="mb-3 w-100"
                            label="PO Number"
                            type="number"
                            name="PO_number"
                            value={
                              getFieldProps("PO_number")?.value ??
                              estimateData?.formikData?.poNumber
                            }
                            onChange={getFieldProps("PO_number")?.onChange}
                            InputProps={{ inputProps: { min: 0 } }}
                            variant="outlined"
                            required
                          />
                        </div>
                        <div className="col-md-4">
                          <TextField
                            className="mb-3 w-100"
                            id="outlined-number"
                            label="Days to Pay"
                            type="number"
                            name="days_to_pay"
                            value={
                              getFieldProps("days_to_pay").value ??
                              estimateData?.formikData?.daysToPay
                            }
                            onChange={getFieldProps("days_to_pay").onChange}
                            InputProps={{ inputProps: { min: 0 } }}
                            variant="outlined"
                            required
                          />
                        </div>
                      </div>
                      {/* /PO NUMBER FIELDS */}

                      {/* TABLE */}
                      <div className="row">
                        <div className="col-md-12">
                          <TableContainer component={Paper}>
                            <Table
                              className={classes.table}
                              aria-label="simple table"
                            >
                              <TableHead>
                                <TableRow>
                                  <TableCell align="center">Actions</TableCell>
                                  <TableCell align="center">Name</TableCell>
                                  <TableCell align="center">
                                    Description
                                  </TableCell>
                                  <TableCell align="center">Rate</TableCell>
                                  <TableCell align="center">Qty</TableCell>
                                  <TableCell align="center">Tax</TableCell>
                                  <TableCell align="center">Total</TableCell>
                                </TableRow>
                              </TableHead>
                              {inputList.map((item, index) => {
                                return (
                                  <TableBody key={index}>
                                    <TableRow>
                                      <TableCell align="center">
                                        <DivTableIcons>
                                          <Edit
                                            style={{ color: "#FC3538" }}
                                            onClick={() =>
                                              handleEditRowOpen(item.prod_id)
                                            }
                                          />
                                          <DeleteIcon
                                            color="error"
                                            onClick={() =>
                                              handleRemoveClick(item.prod_id)
                                            }
                                          />
                                        </DivTableIcons>
                                      </TableCell>
                                      <TableCell align="center">
                                        {item.name}
                                      </TableCell>
                                      <TableCell align="center">
                                        {item.description
                                          ? item.description
                                          : "description"}
                                      </TableCell>
                                      <TableCell align="center">
                                        {item.rate}
                                      </TableCell>
                                      <TableCell align="center">
                                        {item.qty}
                                      </TableCell>
                                      <TableCell align="center">
                                        {item.tax}
                                      </TableCell>
                                      <TableCell align="center">
                                        {item.qty * item.rate}
                                      </TableCell>
                                    </TableRow>
                                  </TableBody>
                                );
                              })}
                            </Table>
                          </TableContainer>
                        </div>
                      </div>
                      {/* /TABLE */}

                      {/* ADD LINE ITEM */}
                      <div className="row mt-2">
                        <div className="col-7 col-sm-4 col-md-3 col-xl-2">
                          <DivAddLine>
                            <button
                              className="btn btn-primary add-line-btn"
                              type="button"
                              onClick={handleAddClick}
                            >
                              <ListItem onClick={handleAddClick}>
                                {/* <ListItemIcon >
                                                      <AddIcon style={{color: '#9c27b0'}} />
                                                  </ListItemIcon> */}
                                <AddIcon
                                  fontSize="small"
                                  style={{
                                    color: "white",
                                  }}
                                />
                                <ListItemText className="text-center">
                                  {
                                    <Typography variant="body2">
                                      Add Line Item
                                    </Typography>
                                  }
                                </ListItemText>
                              </ListItem>
                            </button>
                          </DivAddLine>
                        </div>
                      </div>
                      {/* /ADD LINE ITEM */}

                      {/* SUBTOTAL */}
                      <div class="row mt-2">
                        <div class="col-md-12">
                          <List
                            component="nav"
                            aria-label="secondary mailbox folders"
                          >
                            <ListItem>
                              <ListItemText>Subtotal</ListItemText>
                              <ListItemSecondaryAction>
                                <ListItemText>
                                  $
                                  {subtotal === 0
                                    ? "0.00"
                                    : formatCurrency(subtotal)}
                                </ListItemText>
                              </ListItemSecondaryAction>
                            </ListItem>
                            <Divider />
                            <ListItem>
                              <ListItemText>Markup</ListItemText>
                              <ListItemSecondaryAction>
                                <DivInputFeild>
                                  <input
                                    name="markup"
                                    type="number"
                                    value={addSubTotal.markup}
                                    onBlur={handleSubTotalBlur}
                                    onChange={handleSubTotalChange}
                                  />
                                  <span>$</span>
                                </DivInputFeild>
                              </ListItemSecondaryAction>
                            </ListItem>
                            <Divider />
                            <ListItem>
                              <ListItemText>Discount</ListItemText>
                              <ListItemSecondaryAction>
                                <DivInputFeild>
                                  <input
                                    name="discount"
                                    type="number"
                                    value={addSubTotal.discount}
                                    onBlur={handleSubTotalBlur}
                                    onChange={handleSubTotalChange}
                                  />
                                  <span>$</span>
                                </DivInputFeild>
                              </ListItemSecondaryAction>
                            </ListItem>
                            <Divider />
                            <ListItem>
                              <ListItemText>Tax</ListItemText>
                              <ListItemSecondaryAction>
                                <ListItemText>
                                  $
                                  {totalTax === 0
                                    ? "0.00"
                                    : formatCurrency(totalTax)}
                                </ListItemText>
                              </ListItemSecondaryAction>
                            </ListItem>
                            <Divider />
                          </List>
                        </div>
                      </div>
                      {/* /SUBTOTAL */}

                      <div className="row">
                        <div className="col-md-12">
                          <Box
                            className="text-capitalize"
                            textAlign="right"
                            fontWeight="fontWeightBold"
                            pt={3}
                            pb={3}
                          >
                            <Typography variant="h6">
                              Total (USD) $
                              {total === 0 ? "0.00" : formatCurrency(total)}
                            </Typography>
                          </Box>
                        </div>
                      </div>
                    </div>{" "}
                    {/* /CONTAINER */}
                  </div>
                  {/* ADD CLIENT DIV */}


                  {/* NOTES */}
                  <div style={{ background: "white", borderRadius: "6px" }}>
                    <div className="container mt-4">
                      <div className="row">
                        <div className="col-12">
                          <Box m={2} pb={2}>
                            <div className="row container">
                              <Typography variant="h6">Notes</Typography>
                            </div>
                            <TextField
                              label="Notes"
                              name="notes"
                              fullWidth
                              type="text"
                              multiline
                              rows={3}
                              variant="outlined"
                              value={
                                getFieldProps("notes").value ??
                                estimateData?.formikData?.notes
                              }
                              onChange={getFieldProps("notes").onChange}
                              style={{ marginTop: "15px" }}
                            />
                          </Box>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* NOTES */}

                  {/* PHOTOS */}
                  <div style={{ background: "white", borderRadius: "6px" }}>
                    <div className="container mt-4">
                      <div className="row">
                        <div className="col-12">
                          <Box m={2}>
                            <div className="row container">
                              <Typography variant="h6">
                                Photos
                                <br />
                                <Typography variant="overline">
                                  Add photos to directly in your document and
                                  give your clients a clearer picture of your
                                  work.(Max 10)
                                </Typography>
                              </Typography>
                            </div>
                            <label htmlFor="contained-button-file">
                              <Button
                                  onClick={ImageuploadRest}
                                variant="contained"
                                color="primary"
                                component="span"
                                style={{ borderRadius: 50, marginTop: "10px" }}
                              >
                                Upload
                                <CloudUploadIcon className="ml-2" />
                              </Button>
                              {photoSelectorActions.plainFiles.length > 0 ? (
                                <Button
                                  startIcon={<CancelOutlined />}
                                  onClick={() => Resetphotoupload()}
                                  className="ml-3"
                                  variant="contained"
                                  color="primary"
                                  component="span"
                                  style={{
                                    borderRadius: 50,
                                    marginTop: "10px",
                                  }}
                                >
                                  Cancel
                                </Button>
                              ) : (
                                ""
                              )}
                            </label>
                            {photoSelectorActions.loading ? (
                              <Typography> Loading...</Typography>
                            ) : (
                              <DivShowImages>
                                <Grid container spacing={2}>
                                  {photoSelectorActions.plainFiles.length > 0
                                    ? photoSelectorActions.filesContent.map((item, index) => (
                                      <Grid item xs={3} key={index}>
                                        <div className={classes.imageContainer}>
                                          <img src={item.content} alt={item.name} className={classes.image} />
                                          <TextField
                                            className={classes.descriptionInput}
                                            value={descriptionArray[index]}
                                            onChange={(e) => handleDescriptionChange(e.target.value, index)}
                                            variant="outlined"
                                            placeholder="Add description"
                                          />

                                        </div>
                                      </Grid>
                                    ))
                                    : ''}
                                </Grid>
                              </DivShowImages>
                            )}
                          </Box>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* PHOTOS */}

                  {/* ATTACHMENTS */}
                  <div style={{ background: "white", borderRadius: "6px" }}>
                    <div className="container mt-4">
                      <div className="row">
                        <div className="col-12">
                          <Box m={2}>
                            <div className="row">
                              <Typography variant="h6">
                                Attachments
                                <br />
                                <Typography variant="overline">
                                  Add supporting files, packaged neatly with the
                                  estimate or invoice when you send them.(Max
                                  10)
                                </Typography>
                              </Typography>
                            </div>
                            <label htmlFor="contained-button-file">
                              <Button
                                onClick={() => openAttachmentSelector()}
                                variant="contained"
                                color="primary"
                                component="span"
                                style={{ borderRadius: 50, marginTop: "10px" }}
                              >
                                Upload
                                <CloudUploadIcon className="ml-2" />
                              </Button>
                              {AttachmentSelectorActions.plainFiles.length >
                                0 ? (
                                <Button
                                  startIcon={<CancelOutlined />}
                                  onClick={() =>
                                    AttachmentSelectorActions.clear()
                                  }
                                  className="ml-3"
                                  variant="contained"
                                  color="primary"
                                  component="span"
                                  style={{
                                    borderRadius: 50,
                                    marginTop: "10px",
                                  }}
                                >
                                  Cancel
                                </Button>
                              ) : (
                                ""
                              )}
                            </label>
                            {AttachmentSelectorActions.loading ? (
                              "Loading...."
                            ) : (
                              <DivShowImages>
                                {AttachmentSelectorActions.filesContent.map(
                                  (item, index) => {
                                    return (
                                      <div key={index}>
                                        <button
                                          type="button"
                                          className="btn btn-primary"
                                        >
                                          {item.name}
                                        </button>
                                      </div>
                                    );
                                  }
                                )}
                              </DivShowImages>
                            )}
                          </Box>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* ATTACHMENTS */}
                </form>
              </div>
            </div>
          </div>
        </div>
      );
    }
  } else {
    return <Redirect to="/"></Redirect>;
  }
};

export default NewEstimate;

const DivAddLine = styled.div`
  // width: 100%;
  margin-top: 15px;
  background-color: transparent;
  cursor: pointer;
  button {
    width: 100%;
    height: 80px;
    cursor: pointer;
    color: #9c27b0;
    border: 0.5px solid #9c27b0;
    border-radius: 5px;
    background-color: transparent;
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.15);
    transition: all 0.25s ease-in-out;
  }
  &:hover {
    transition: all 0.35s ease-in-out;
    background-color: rgba(0, 0, 0, 0.05);
  }
  .add-line-btn {
    // width: auto;
    height: auto;
    padding: 0;
    text-transform: capitalize;
  }
`;

const DivNewInvoiceHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 10px;
  background-color: white;
  border-radius: 6px;
  padding: 14px;
  button {
    margin: 0px 5px;
  }
`;

const DivTableIcons = styled.div`
  * {
    margin: 0px 5px;
    cursor: pointer;
    font-size: 20px;
    opacity: 0.9;
    transition: 0.25s all ease-in-out;
    &:hover {
      transition: 0.25s all ease-in-out;
      opacity: 1;
    }
  }
`;

const DivTableRowEdit = styled.div`
  padding: 5px;
  max-width: 600px;
  .qty {
    display: flex;
    margin-top: 15px;
  }
  .btns {
    margin-top: 15px;
    display: flex;
    justify-content: right;
    .cancel {
      margin-right: 10px;
    }
  }
  .radio {
    .MuiRadio-colorSecondary.Mui-checked {
      color: #premium;
    }
  }
`;
const DivInputFeild = styled.div`
  float: right;
  input {
    background-color: rgba(0, 0, 0, 0.05);
    border: none;
    width: 50px;
    margin-right: -15px;
  }
  span {
    font-weight: bolder;
    position: relative;
    left: -45px;
  }
`;

const DivContractCheckboxes = styled.div`
  .list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    // max-width: 500px;
    margin: 5px 0px;
    .list-content {
      max-width: 600px;
    }
    .list-checkbox {
      .css-12wnr2w-MuiButtonBase-root-MuiCheckbox-root.Mui-checked {
        color: #fc3538 !important;
      }
    }
  }
`;

const DivShowImages = styled.div`
  margin-top: 15px;

  img {
    margin: 5px;
    width: 150px;
    height: 150px;
    object-fit: cover;
    cursor: pointer;
    opacity: 0.8;
    transition: 0.25s all ease-in-out;
  }
  .icon {
    position: relative;
    right: 90px;
    top: 15px;
    opacity: 0.6;
    cursor: pointer;
    transition: 0.25s all ease-in-out;
    &:hover {
      opacity: 0.8;
    }
  }
`;
